import React, { useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { MdOutlineClose, MdOutlineCheck, MdImageAspectRatio, MdImage } from "react-icons/md";
import { Input, Button, Select } from "react-daisyui";
// import { CityStore, CityStoreContext } from "./store/CityStore";
// import { AdminUseStore, useAdminUsedStore, AdminUserStoreContext } from "./store/AdminUsersStore";
import { useLocationStore, LocationStore, LocationStoreContext } from "./store/LocationStore";
import { observer } from "mobx-react";
import { useAuthStore } from "../Auth/store/Auth";
import { useState } from "react";
import { RxEyeClosed, RxEyeOpen } from "react-icons/rx";
import { toast } from "react-toastify";

const EditLocation = observer(() => {
    const { id } = useParams();

    return (
        <LocationStoreContext.Provider
            value={
                new LocationStore({
                    getLocationDetails: true,
                    id: id
                })
            }
        >
            <Screen />
        </LocationStoreContext.Provider>
    );
});
export default EditLocation;
const Screen = observer(() => {
    const { updateLocation, getToken, EditLocation, setLocationFormDetails , setstate_name ,  getstateList , setcountry_name  ,getcountriesList  , country_obj ,countries  , state ,   LocationFormDetails , saved, EditloadLocation } = useLocationStore();
    const { adminAuthApproved } = useAuthStore();
    const { id } = useParams();

    // const [crop, setCrop] = useState({ aspect: 16 / 9, dimensions: { width: 480, height: 270 } });
    // const { register, handleSubmit, errors } = useForm();

    const onSubmit = (data) => {
        // Handle form submission logic here
        console.log(data);
    };

    useEffect(() => {
        if (adminAuthApproved) {
            getToken(localStorage.getItem("Admintoken"));
        }

    }, [adminAuthApproved]);
    const navigate = useNavigate();
console.log(country_obj);

    useEffect(() => {
        if (saved) {
            navigate(-1);
        }
    }, [saved]);
    useEffect(() => {
     
            getstateList(LocationFormDetails.country_code);
    
    }, [LocationFormDetails.country_code]);



    const handleSubmit = (e) => {
        e.preventDefault();
        updateLocation(id);
        // Perform API call or any other logic using MobX store data
        // Example: EditCity();
    };

console.log("LocationFormDetails.state_code==",LocationFormDetails.state_code);

    return (
        <>
          <div className="flex justify-between mt-[51px] ">
                <div className=" mb-4">
                    <p className=" text-2xl font-semibold"> Edit Location </p>
                    <p className=" opacity-80 text-sm">Home / Location / Edit Location </p>
                </div>
                <div>

                    <Link
                        onClick={() => navigate(-1)}
                        className="btn btn-sm bg-[#000] text-color_theme text-sm hover:bg-[#000]"
                    >
                        Back
                    </Link>
                </div>
            </div>
            <div className="card bg-base-100 shadow-md p-6 mt-8">
                <form onSubmit={handleSubmit}>
                    <div className="grid lg:grid-cols-3 md:grid-cols-2 md:gap-8 gap-4">
                    <div>
                            <label
                                htmlFor="Status"
                                className="block text-sm font-semibold text-zinc-700 dark:text-stone-400 mb-2"
                            >
                                Country

                            </label>

                            <select
                                id="Status"
                                required
                                value={LocationFormDetails.country_code}
                                onChange={(e) => {
                                    setLocationFormDetails({
                                        ...LocationFormDetails,
                                        country_code: e.target.value,
                                    });
                                    getstateList(e.target.value);
                                }}
                                onChangeCapture={(e)=> setcountry_name( e.target.options[e.target.selectedIndex].dataset)}
                                // onChange={(e) => {getstateList(e.target.value); setcountry_name( e.target.options[e.target.selectedIndex].dataset)  }}
                                name="Status"
                                className={`select focus:outline-0 w-full text-sm font-medium rounded-md focus:outline-offset-0 select-bordered`}
                            >
                                <option value="0">{LocationFormDetails.country_name ? LocationFormDetails.country_name : "Country" }</option>

                                {countries.map((type, index) => (
                                    <option key={index}  value={type.countryId}
                                    data-countryId ={type?.countryId}
                                    data-countryName ={type?.countryName}
                                    
                                    >{type.countryName}</option>
                                ))}

                                {/* <option value="India"     >India</option>
                                <option value="Australia"      >Australia</option>
                                <option value="Singapore"       >Singapore</option>
                                <option value="Japan"       >Japan</option>
                                <option value="Nepal"     >Nepal</option> */}

                            </select>
                        </div>
                 
                        <div>
                            <label
                                htmlFor="Status"
                                className="block text-sm font-semibold text-zinc-700 dark:text-stone-400 mb-2"
                            >
                                State

                            </label>
                         
                            <select
                                id="Status"
                                required={LocationFormDetails.state_code==""}
                                value={LocationFormDetails.state_code}
                                onChange={(e) => {
                                    setLocationFormDetails({
                                        ...LocationFormDetails,
                                        state_code: e.target.value,
                                    });
                                }}
                                onChangeCapture={(e)=> setstate_name( e.target.options[e.target.selectedIndex].dataset)}
                                // onChange={(e) => setstate_name( e.target.options[e.target.selectedIndex].dataset)  }
                                name="Status"
                                className={`select focus:outline-0 w-full text-sm font-medium rounded-md focus:outline-offset-0 select-bordered`}
                            >
                                <option value="0">{LocationFormDetails.state_name ? LocationFormDetails.state_name:"State" }</option>

                                {state.map((type, index) => (
                                    <option key={index}  
                                    value={type.stateId}
                                    data-stateId ={type?.stateId}
                                    data-stateName ={type?.stateName}
                                    >{type.stateName}</option>
                                ))}
                                {/* <option value="rajasthan" >rajasthan</option>
                                <option value="goa"        >goa</option>
                                <option value="Madhya pradesh"        >Madhya pradesh</option>
                                <option value="Aruncachal pradesh"        >Aruncachal pradesh</option>
                                <option value="keral"        >keral</option> */}

                            </select>
                        </div>

                        <div>
                            <label
                                htmlFor="name"
                                className="block text-sm font-semibold text-zinc-700 dark:text-stone-400 mb-2"
                            >
                               City<span className="text-[#f00]">&nbsp;*</span>
                            </label>
                            <Input
                                name="city"
                                required
                                placeholder="city"
                                value={LocationFormDetails.city}
                                onChange={(e) => {
                                    setLocationFormDetails({
                                        ...LocationFormDetails,
                                        city: e.target.value,
                                    });
                                }}
                                id="city"
                                type="text"
                                autoComplete="off"
                                className=" focus:outline-0 w-full text-sm font-medium rounded-md"
                            />

                        </div>
                  
                        <div>
                            <label
                                htmlFor="name"
                                className="block text-sm font-semibold text-zinc-700 dark:text-stone-400 mb-2"
                            >
                                PIN Code<span className="text-[#f00]">&nbsp;*</span>
                            </label>
                            <Input
                                name="CODE"
                                required
                                placeholder="CODE"
                                value={LocationFormDetails.pincode}
                                onChange={(e) => {
                                    setLocationFormDetails({
                                        ...LocationFormDetails,
                                        pincode: e.target.value,
                                    });
                                }}
                                id="CODE"
                                min={1}
                                type="number"
                                autoComplete="off"
                                className=" focus:outline-0 w-full text-sm font-medium rounded-md"
                            />

                        </div>
                    </div>




                    <div className="lg:mt-3 mt-4 flex items-center md:justify-end justify-between">
                        <Link
                            onClick={() => navigate(-1)}

                            className="btn btn-md bg-[#000] text-color_theme text-sm hover:bg-[#000]"
                        >
                            <MdOutlineClose className="mr-1" />
                            Cancel
                        </Link>
                        {!EditloadLocation ?
                            <button className="btn btn-md bg-color_theme text-[#000] text-sm hover:text-color_theme hover:bg-[#000] ml-4">
                                <MdOutlineCheck className="mr-1" />
                                Edit Location
                            </button>
                            :
                            <button
                                className="btn btn-md bg-color_theme text-[#000] text-sm hover:text-color_theme hover:bg-[#000] ml-4"
                                type="button"
                            //  onClick={()=> changeStep("4")}
                            >
                                <svg
                                    className="animate-spin mr-1 h-5 w-5 text-white"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                >
                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                    <path
                                        className="opacity-75"
                                        fill="currentColor"
                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                    ></path>
                                </svg>
                                Loading..
                            </button>
                        }

                    </div>
                </form>
            </div>
        </>
    );
});

